import React, { useEffect, useState } from 'react';
import { ThemeToggle } from './ThemeToggle';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Work',
    path: '/work'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b-2 border-black" data-id="element-114">
        <div className="container mx-auto px-0 flex items-stretch h-20" data-id="element-115">
          {/* Logo */}
          <Link to="/" className="flex items-center px-6 border-r-2 border-black hover:bg-swiss-red hover:text-white transition-colors group" data-id="element-116">
            <span className="font-heading font-black text-2xl tracking-tighter uppercase" data-id="element-117">
              Pixel
              <span className="text-swiss-red group-hover:text-white" data-id="element-118">
                Perfect
              </span>
            </span>
          </Link>

          <div className="flex-1" data-id="element-119"></div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-stretch" data-id="element-120">
            {navLinks.map(item => <Link key={item.name} to={item.path} className={`flex items-center px-6 border-l-2 border-black text-sm font-bold uppercase tracking-wider hover:bg-black hover:text-white transition-colors ${location.pathname === item.path ? 'bg-black text-white' : 'text-black'}`} data-id="element-121">
                {item.name}
              </Link>)}
            <div className="flex items-center px-6 border-l-2 border-black" data-id="element-122">
              <ThemeToggle data-id="element-123" />
            </div>
            <Link to="/contact" className="flex items-center px-8 border-l-2 border-black bg-swiss-red text-white font-bold uppercase tracking-wider hover:bg-black transition-colors" data-id="element-124">
              Let's Talk
            </Link>
          </nav>

          {/* Mobile Toggle */}
          <div className="flex md:hidden items-stretch" data-id="element-125">
            <div className="flex items-center px-4 border-l-2 border-black" data-id="element-126">
              <ThemeToggle data-id="element-127" />
            </div>
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="flex items-center px-6 border-l-2 border-black hover:bg-black hover:text-white transition-colors" data-id="element-128">
              {isMenuOpen ? <X size={24} data-id="element-129" /> : <Menu size={24} data-id="element-130" />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-131">
        {isMenuOpen && <motion.div className="fixed inset-0 z-40 bg-white pt-20" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.2
      }} data-id="element-132">
            <nav className="flex flex-col border-t-2 border-black" data-id="element-133">
              {navLinks.map(item => <Link key={item.name} to={item.path} className="py-6 px-6 border-b-2 border-black text-2xl font-heading font-black uppercase hover:bg-black hover:text-white transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-134">
                  {item.name}
                </Link>)}
              <Link to="/contact" className="py-6 px-6 border-b-2 border-black text-2xl font-heading font-black uppercase bg-swiss-red text-white hover:bg-black transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-135">
                Start a Project
              </Link>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </>;
}